import { createSelector } from 'reselect';
import { State } from 'reducers';
import { FeatureVisibility } from 'shared/models';
import { pickBy } from 'lodash';
import { initialState } from 'reducers/featuresReducer';

export const getFeaturesState =
    (state: State) => (state || initialState).features;

export const getFeatureVisibility =
    createSelector(
        getFeaturesState,
        state => state.visibility
    );

export const getOptInFeatures =
    createSelector(
        getFeatureVisibility,
        visibility => pickBy(visibility, fv => fv === FeatureVisibility.MadAdminsOptIn || fv === FeatureVisibility.UserOptIn)
    );
